/* TP 2026-10 — filter och sortering (snippets/tp-filters.liquid).

   Formuläret är ett vanligt GET-formulär med Shopifys filterparametrar och
   fungerar utan skript. Det här skriptet gör fyra saker:

     1. Ett val uppdaterar listan direkt, utan sidladdning: sektionen hämtas
        om med samma parametrar (Shopifys section rendering) och tre delar
        byts ut — filterblocket, rutnätet och antalet. Adressraden följer med,
        så att bakåtknappen och delade länkar ger samma urval.
     2. Panelen ("Filtrera & sortera") glider in från höger, likadant på
        dator och mobil: öppna, stäng, Escape, klick på ytan bakom. Fokus
        stannar i panelen medan den är öppen och går tillbaka till knappen
        när den stängs. Sidan bakom står still.
     3. Efter en uppdatering står panelen kvar öppen med samma rader
        utfällda (även de man fällt ihop), samma rullningsläge och fokus på
        samma ruta — man kan kryssa i flera val i rad.
     4. Sökrutan i långa listor (Märke, Smak …): filtrerar valen medan man
        skriver. Rutan har inget namn och skickas aldrig med formuläret.

   Rutnätet byts ut på plats (#ProductGridContainer behåller sitt element),
   så "Visa fler" och kampanjflikarna fortsätter fungera. Efteråt skickas
   händelsen tp:grid-updated.
*/
(function () {
  'use strict';

  var controller = null;
  var timer = null;

  function root() {
    return document.querySelector('[data-tp-filters]');
  }

  function form() {
    var r = root();
    return r && r.querySelector('[data-tp-filters-form]');
  }

  function panel() {
    var r = root();
    return r && r.querySelector('[data-tp-filters-panel]');
  }

  /* ---- Panelen -------------------------------------------------------------- */
  function sheetOpen() {
    var p = panel();
    return !!(p && p.classList.contains('is-open'));
  }

  /* Sidan bakom låses medan panelen är öppen. På dator försvinner då
     rullningslisten; lika mycket utrymme läggs till till höger, så att
     sidan inte hoppar i sidled. */
  function lockPage(lock) {
    var body = document.body;
    if (lock) {
      if (body.classList.contains('tp-filters-open')) return;
      var bar = window.innerWidth - document.documentElement.clientWidth;
      body.classList.add('tp-filters-open');
      if (bar > 0) body.style.paddingRight = bar + 'px';
    } else {
      body.classList.remove('tp-filters-open');
      body.style.paddingRight = '';
    }
  }

  function openSheet(animate) {
    var r = root();
    var p = panel();
    if (!r || !p) return;
    if (animate === false) r.classList.add('is-instant');
    r.classList.add('is-sheet-open');
    p.classList.add('is-open');
    lockPage(true);
    var opener = r.querySelector('[data-tp-filters-open]');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    if (animate !== false) {
      var close = p.querySelector('.tp-filters__x');
      if (close) {
        try { close.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { r.classList.remove('is-instant'); });
    });
  }

  function closeSheet() {
    var r = root();
    var p = panel();
    if (!r || !p) return;
    r.classList.remove('is-sheet-open');
    p.classList.remove('is-open');
    lockPage(false);
    var opener = r.querySelector('[data-tp-filters-open]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      try { opener.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  /* Tabb stannar i panelen medan den är öppen. */
  function trapFocus(event) {
    var p = panel();
    if (!p || !sheetOpen()) return;
    var items = Array.prototype.filter.call(
      p.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), summary'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!p.contains(active)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---- Sök i långa listor ------------------------------------------------ */
  function filterList(input) {
    var body = input.closest('.tp-filter__body');
    var list = body && body.querySelector('[data-tp-filter-list]');
    if (!list) return;
    var q = input.value.trim().toLowerCase();
    list.classList.toggle('is-searching', q !== '');
    list.querySelectorAll('.tp-filter__item').forEach(function (li) {
      var name = li.querySelector('.tp-filter__name');
      var text = (name ? name.textContent : li.textContent || '').toLowerCase();
      li.classList.toggle('is-filtered-out', q !== '' && text.indexOf(q) === -1);
    });
  }

  /* ---- Hämta och byt ut ------------------------------------------------- */
  function query() {
    var f = form();
    if (!f) return '';
    var params = new URLSearchParams();
    var defaultSort = f.getAttribute('data-default-sort') || '';
    new FormData(f).forEach(function (value, key) {
      if (String(value).trim() === '') return;
      /* Standardsorteringen behöver inte stå i adressen. */
      if (key === 'sort_by' && value === defaultSort) return;
      params.append(key, value);
    });
    return params.toString();
  }

  function state() {
    var r = root();
    var ids = [];
    var open = [];
    var searches = [];
    var scroll = 0;
    if (r) {
      r.querySelectorAll('details[data-tp-filter]').forEach(function (d) {
        if (!d.id) return;
        ids.push(d.id);
        if (d.open) open.push(d.id);
      });
      r.querySelectorAll('[data-tp-filter-search]').forEach(function (input) {
        var d = input.closest('details');
        if (d && d.id && input.value) searches.push({ id: d.id, q: input.value });
      });
      var box = r.querySelector('[data-tp-filters-scroll]');
      if (box) scroll = box.scrollTop;
    }
    var active = document.activeElement;
    return {
      ids: ids,
      open: open,
      searches: searches,
      scroll: scroll,
      sheet: sheetOpen(),
      focus: active && active.id && r && r.contains(active) ? active.id : '',
      moreOpen: r ? Array.prototype.map.call(r.querySelectorAll('[data-tp-filter-more][aria-expanded="true"]'), function (b) {
        var d = b.closest('details');
        return d ? d.id : '';
      }) : []
    };
  }

  function restore(s) {
    var r = root();
    if (!r) return;
    /* Samma rader utfällda som innan — även de man fällt ihop för hand.
       Rader som är nya sedan förra gången behåller sitt eget läge. */
    r.querySelectorAll('details[data-tp-filter]').forEach(function (d) {
      if (!d.id) return;
      if (s.open.indexOf(d.id) > -1) d.setAttribute('open', '');
      else if (s.ids.indexOf(d.id) > -1) d.removeAttribute('open');
    });
    s.moreOpen.forEach(function (id) {
      var d = id && document.getElementById(id);
      if (d) expandMore(d.querySelector('[data-tp-filter-more]'));
    });
    s.searches.forEach(function (item) {
      var d = document.getElementById(item.id);
      var input = d && d.querySelector('[data-tp-filter-search]');
      if (!input) return;
      input.value = item.q;
      filterList(input);
    });
    if (s.sheet) openSheet(false);
    var box = r.querySelector('[data-tp-filters-scroll]');
    if (box && s.scroll) box.scrollTop = s.scroll;
    var el = s.focus ? document.getElementById(s.focus) : null;
    /* Fanns det man stod på inte kvar (t.ex. "Rensa alla", som försvinner
       när inget filter är valt) hamnar fokus på stängknappen, så att det
       stannar i panelen. */
    if (!el && s.sheet) el = r.querySelector('.tp-filters__x');
    if (el) {
      try { el.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function swap(doc) {
    var r = root();
    var nr = doc.querySelector('[data-tp-filters]');
    if (r && nr) r.replaceWith(nr);

    var grid = document.getElementById('ProductGridContainer');
    var ngrid = doc.getElementById('ProductGridContainer');
    if (grid && ngrid) grid.innerHTML = ngrid.innerHTML;

    document.querySelectorAll('[data-tp-results-count]').forEach(function (el, i) {
      var source = doc.querySelectorAll('[data-tp-results-count]')[i];
      if (source) el.innerHTML = source.innerHTML;
    });
  }

  function render(search, push) {
    var r = root();
    if (!r) return;
    var sectionId = r.getAttribute('data-section-id');
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + (search ? '&' + search : '');

    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;

    var grid = document.getElementById('ProductGridContainer');
    if (grid) grid.classList.add('is-loading');
    r.classList.add('is-loading');

    var s = state();

    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swap(doc);
        restore(s);
        if (push !== false) {
          var next = window.location.pathname + (search ? '?' + search : '');
          window.history.pushState({ tpFilters: search }, '', next);
        }
        var g = document.getElementById('ProductGridContainer');
        if (g) g.classList.remove('is-loading');
        if (typeof window.tp2SyncFavoriteButtons === 'function') {
          var list = document.getElementById('product-grid');
          if (list) window.tp2SyncFavoriteButtons(list);
        }
        document.dispatchEvent(new CustomEvent('tp:grid-updated', { bubbles: true }));
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        /* Går hämtningen fel: ladda sidan på vanligt sätt. */
        window.location.href = window.location.pathname + (search ? '?' + search : '');
      });
  }

  function apply(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      render(query(), true);
    }, delay || 0);
  }

  /* ---- Pris ---------------------------------------------------------------
     Två fält och två reglage. Reglagen har inget namn och skickas inte —
     de skriver bara till fälten. Listan uppdateras när man släpper reglaget
     eller lämnar fältet, inte för varje steg. */
  function syncSlider(box) {
    var from = box.querySelector('[data-tp-price-slider="from"]');
    var to = box.querySelector('[data-tp-price-slider="to"]');
    var range = box.querySelector('.tp-filter__range');
    if (!from || !to || !range) return;
    range.style.setProperty('--tp-from', from.value);
    range.style.setProperty('--tp-to', to.value);
  }

  function onSlider(input, commit) {
    var box = input.closest('[data-tp-price]');
    if (!box) return;
    var from = box.querySelector('[data-tp-price-slider="from"]');
    var to = box.querySelector('[data-tp-price-slider="to"]');
    var max = Number(to.max);
    if (Number(from.value) > Number(to.value)) {
      if (input === from) from.value = to.value;
      else to.value = from.value;
    }
    syncSlider(box);
    var fieldFrom = box.querySelector('[data-tp-price-from]');
    var fieldTo = box.querySelector('[data-tp-price-to]');
    fieldFrom.value = Number(from.value) > 0 ? from.value : '';
    fieldTo.value = Number(to.value) < max ? to.value : '';
    if (commit) apply(0);
  }

  /* ---- "Visa alla" i långa listor ---------------------------------------- */
  function expandMore(button) {
    if (!button) return;
    var list = button.parentElement.querySelector('[data-tp-filter-list]');
    if (list) list.classList.add('is-expanded');
    button.setAttribute('aria-expanded', 'true');
    button.hidden = true;
  }

  /* ---- Händelser (delegerade, så de överlever utbytet) ------------------ */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.closest || !target.closest('[data-tp-filters-form]')) return;
    if (target.matches('[data-tp-filter-search]')) return;
    if (target.matches('[data-tp-price-slider]')) {
      onSlider(target, true);
      return;
    }
    if (target.matches('[data-tp-price-from], [data-tp-price-to]')) {
      apply(0);
      return;
    }
    apply(120);
  });

  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target.matches) return;
    if (target.matches('[data-tp-filter-search]')) {
      filterList(target);
      return;
    }
    if (target.matches('[data-tp-price-slider]')) onSlider(target, false);
  });

  /* Enter i prisfältet ska inte skicka formuläret på gammalt sätt. */
  document.addEventListener('submit', function (event) {
    if (!event.target.matches || !event.target.matches('[data-tp-filters-form]')) return;
    event.preventDefault();
    apply(0);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-tp-filters-link]');
    if (link) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      var href = new URL(link.href, window.location.href);
      render(href.search.replace(/^\?/, ''), true);
      return;
    }

    if (event.target.closest('[data-tp-filters-open]')) {
      openSheet(true);
      return;
    }

    if (event.target.closest('[data-tp-filters-close]')) {
      closeSheet();
      return;
    }

    var more = event.target.closest('[data-tp-filter-more]');
    if (more) expandMore(more);
  });

  document.addEventListener('keydown', function (event) {
    /* Enter i sökrutan ska inte skicka formuläret. */
    if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-tp-filter-search]')) {
      event.preventDefault();
      return;
    }
    if (event.key === 'Tab') {
      trapFocus(event);
      return;
    }
    if (event.key === 'Escape' && sheetOpen()) closeSheet();
  });

  window.addEventListener('popstate', function () {
    if (!root()) return;
    render(window.location.search.replace(/^\?/, ''), false);
  });

  function init() {
    document.querySelectorAll('[data-tp-price]').forEach(syncSlider);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('tp:grid-updated', init);
})();
